import releaseMeta from "../releases/2026.06-nav-overhaul/release.meta.json";

/**
 * Build-time release identity. APP_BUILD is diagnostic only — never used for tour triggers.
 */
export const APP_RELEASE_ID =
  process.env.REACT_APP_RELEASE_ID || releaseMeta.releaseId;

export const APP_VERSION =
  process.env.REACT_APP_VERSION || releaseMeta.version || "0.1.0";

export const APP_BUILD =
  process.env.REACT_APP_BUILD ||
  (releaseMeta.versionCode != null ? String(releaseMeta.versionCode) : null);
